var map = {
	"./channel_bg1.jpg": "Wytb",
	"./channel_bg2.jpg": "JUzH",
	"./channel_bg3.jpg": "KL4Q",
	"./channel_bg4.jpg": "nKGa",
	"./channel_bg5.jpg": "zXV/"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dXYW";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/channel_bg.*\.jpg$
// module id = dXYW
// module chunks = 96